import styled from 'styled-components'

export const ReportCardItemDiv = styled.div`
  height: auto;
  background-color: #6ebf4b;
  width: 100%;
  border-radius: 20px;
  padding: 1rem 0.5rem;
`

export const ItemText = styled.span`
  font-size: 18px;
  color: white;

  ${(props) => props.bold && `font-weight: bold;`}
`



// WEBPACK FOOTER //
// ./src/pages/Reports/index.style.js